import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { PaymentMethodType, WalletPaymentMethodType } from '@platform-frontend/marketplace';
import { Observable } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';
import { CheckoutPaymentInformationState } from '../checkout-payment-information.state';

@Component({
  selector: 'yat-add-new-payment-method',
  templateUrl: './add-new-payment-method.component.html',
  styleUrls: ['./add-new-payment-method.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class AddNewPaymentMethodComponent {
  constructor(private store: Store) {}

  @Input()
  selectedWalletPaymentMethodType: WalletPaymentMethodType | null = null;

  @Output()
  add = new EventEmitter<PaymentMethodType>();

  addablePaymentMethodTypes$: Observable<PaymentMethodType[]> = this.store.select(CheckoutPaymentInformationState.addablePaymentMethodTypes);

  selectPaymentMethod(type: PaymentMethodType): void {
    this.add.emit(type);
  }
}
